export const PERMISSIONS = {
  USERS_MANAGE: 'users:manage',
  SETTINGS_MANAGE: 'settings:manage',
  INVOICE_WRITE: 'invoice:write',

  // SOLY-PERM-001 — planning & commandes fournisseurs. Voir / Gérer, des deux côtés.
  PLANNING_READ: 'planning:read',
  PLANNING_MANAGE: 'planning:manage',
  ORDERS_READ: 'orders:read',
  ORDERS_MANAGE: 'orders:manage',

  // Accepting a quote; also guards the gestures that move revenue (delete a sale, merge customers).
  QUOTE_ACCEPT: 'quote:accept',
} as const

/** Same code as CustomerMergeService.MergePermission on the backend: change both together. */
export const CUSTOMER_MERGE_PERMISSION = PERMISSIONS.QUOTE_ACCEPT

export type PermissionCode = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]

/** Ce que porte `permissions[]` de la session — la source unique côté front. */
export interface PermissionCarrier {
  permissions?: string[]
}

export function hasPermission(user: PermissionCarrier | null | undefined, code: PermissionCode): boolean {
  return user?.permissions?.includes(code) ?? false
}

/**
 * Le message affiché quand une action est visible mais désactivée.
 *
 * On grise plutôt qu'on ne masque : un bouton qui disparaît se lit comme un bug, et l'utilisateur
 * appelle le patron pour dire « Soly ne marche plus ». Un bouton grisé qui dit pourquoi enseigne le
 * modèle de droits en une lecture. Les *pages* entières, elles, sont bien masquées (une entrée de
 * menu qui mène à un 403 n'apprend rien).
 */
export const PERMISSION_DENIED_HINT: Record<PermissionCode, string> = {
  [PERMISSIONS.USERS_MANAGE]: "Réservé aux personnes qui gèrent l'équipe.",
  [PERMISSIONS.SETTINGS_MANAGE]: "Réservé aux personnes qui gèrent les paramètres de l'entreprise.",
  [PERMISSIONS.INVOICE_WRITE]: 'Réservé aux personnes qui gèrent la facturation.',
  [PERMISSIONS.PLANNING_READ]: "Vous n'avez pas accès au planning.",
  [PERMISSIONS.PLANNING_MANAGE]: 'Réservé aux personnes qui gèrent le planning.',
  [PERMISSIONS.ORDERS_READ]: "Vous n'avez pas accès aux commandes fournisseurs.",
  [PERMISSIONS.ORDERS_MANAGE]: 'Réservé aux personnes qui gèrent les commandes fournisseurs.',
  [PERMISSIONS.QUOTE_ACCEPT]: 'Réservé aux personnes qui peuvent accepter un devis.',
}
